export { CLIENT_ID } from "env";

export const TENANT_ID = "28c25355-d98b-4a65-8b33-c5e4bb122676";
export const BASE_AUTHORITY = "https://sts.windows.net";
export const SCOPE = "App.Login";
